// src/App.jsx (or App.js)
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';

import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import HowItWorks from './pages/HowItWorks';
import AuthCallback from './pages/AuthCallback';
import EmailConfirmed from './pages/EmailConfirmed';
import Logs from './pages/Logs';

// ——— ProtectedRoute (login temporarily disabled — access is always allowed) ———
function ProtectedRoute({ children }) {
  return children;
}

// ——— Authentication temporarily removed ———
export default function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> {/* Reuse PrivacyPolicy for T&C */}
          <Route path="/how-it-works" element={<HowItWorks />} /> {/* Reuse PrivacyPolicy for How It Works */}

          {/* Login route */}
          <Route path="/login" element={<Login />} />

          {/* Sign Up route */}
          <Route path="/signup" element={<SignUp />} />

          {/* Auth callback route (for email confirmation) */}
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Email confirmed page */}
          <Route path="/email-confirmed" element={<EmailConfirmed />} />

          {/* Logs page */}
          <Route path="/logs" element={<Logs />} />

          {/* Protected /dashboard route */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* Fallback: Redirect anything else to "/" */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}
